import DinamicDashboardComponent from '@components/DinamicDashboardComponent';
import PageWithoutTitle from '@components/PageWithoutTitle';
import ConfigService from '@services/global/Config';
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor';
import styled from '@src/styled-components';
import React from 'react';

import I18n from '../i18n';
import AppContext from '../services/Context';
import { LocalStorageKeys } from './App';

const _formflowService: ProcessRequestsInterceptor = new ProcessRequestsInterceptor()

type PropType = { history: { replace: Function }; match: any; }

type StateType = {
  isLoading: boolean;
  iconLoading?: boolean;
  userFields?: any;
  menuItems: any;
  processes: [];
  dashboardTitle: string;
};

class Dashboard extends React.Component<PropType, StateType> {
  private _configService: ConfigService = new ConfigService();

  private idUnit: any = undefined;
  private currentPillar: any;

  constructor(props: any) {
    super(props);
    this.state = {
      dashboardTitle: '',
      isLoading: false,
      menuItems: undefined,
      processes: []
    }
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
    this.changeTitle = this.changeTitle.bind(this)
  }

  componentDidMount() {
    this.getConfig();
    this.getProcesses()
  }

  setUnit(unit: string) {
    this.idUnit = unit;
  }

  changeTitle(title: string) {
    this.setState({ dashboardTitle: title })
  }

  getConfig = async () => {
    const response = await this._configService.getGLOBAL(['userFields']);
    if (response.userFields != undefined) {
      let fields: string[] = [];

      response.userFields.map((item) => {
        fields.push(item.name ? item.name : '');
      });

      this.setState({
        userFields: fields,
      });
    }
  }


  getProcesses = async () => {
    const data: any = await _formflowService.paging({
      unit: this.idUnit,
      to: undefined,
      from: undefined,
      limit: 100,
    }, ['id', 'name', 'paths']);

    this.setState({ processes: data })
  }

  render() {
    const {
      isLoading
    } = this.state;

    if (!!isLoading) {
      return (
        <AppContext.Consumer>
          {({ locale, activeUnitId }) => (
            this.setUnit(activeUnitId),
            <span>{I18n.l('common.loadingTable')}</span>
          )}
        </AppContext.Consumer>
      );
    }
    return (
      <PageWithoutTitle>
        <h1 style={{ fontSize: '48px', fontWeight: 'bolder' }}>{this.currentPillar === 'EHSS' ? I18n.l('dashboard.lite') : this.state.dashboardTitle}</h1>
        <AppContext.Consumer>
          {({ activeUnitId }) => (
            this.setUnit(activeUnitId),
            <Wrapper key="liteDashboard_wrapper">
              <DinamicDashboardComponent unit={this.idUnit} pillar={this.currentPillar} matchData={this.props.match} changeTitle={this.changeTitle} />
            </Wrapper>
          )}
        </AppContext.Consumer>
      </PageWithoutTitle >
    );
  }
}

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .side-margin{
      margin: 0 20;
    }

    .main-button {
        font-weight: bold;
        text-transform: uppercase;
        font-size:15px;
    }
    .loading-more {
        margin: 15px 0;
        padding: 0;
        border: 0;
        text-align: left
    }

    .filter-group {
        margin-bottom: 50px;
    }
   
    hr{
        opacity: .6;
    }
`;

export default Dashboard;
